import { Link } from 'react-router-dom';
import Modal from '../../../../commons/Modal/Modal';
import { ModalProps } from '../../../../commons/Modal/Modal.types';
import Button from '../../../../designSystem/Button/Button';

export default (props: ModalProps) => {
  return (
    <Modal {...props}>
      <h2>Votre mot de passe a bien été pris en compte</h2>
      <p>Vous pouvez désormais vous identifier pour accéder à votre espace.</p>
      <Link to="/login/commercial">
        <Button>Me connecter</Button>
      </Link>
    </Modal>
  );
};
